export const editableFields = ['HPSpend']
